module.exports = __webpack_public_path__ + "static/media/5.48ef682f.jpg";